<script setup lang="ts">
    import useWhenTenantReady from '~/composables/useWhenTenantReady';

    const setIntercomData = async () => {
        const { load: loadSender, isEinvoicingSenderNetworkActivated } = useGetEinvoicingSender();
        const { load: loadReceiver, isEinvoicingReceiverNetworkActivated } = useGetEinvoicingReceiver();
        await Promise.all([loadSender(), loadReceiver()]);

        useIntercomUpdate({
            trustup_pro_manager_einvoicing_sender_activated: isEinvoicingSenderNetworkActivated.value,
            trustup_pro_manager_einvoicing_receiver_activated: isEinvoicingReceiverNetworkActivated.value,
        });
    };

    const init = () => {
        return Promise.all([setIntercomData()]);
    };

    onMounted(() => {
        useWhenTenantReady(() => init());
    });
</script>

<template>
    <NuxtLayout name="base">
        <template #default>
            <slot />
        </template>
    </NuxtLayout>
</template>
